<div class="rp-dialog">
    <div class="rp-header">
        <div class="rp-icon">
            <mat-icon>
                {{ isFirstTimeSetup ? 'lock_open' : 'lock_reset' }}
            </mat-icon>
        </div>
        <h2 class="rp-title">
            {{
                isFirstTimeSetup
                    ? 'Create your password'
                    : 'Change your password'
            }}
        </h2>
        <p class="rp-subtitle">
            <ng-container *ngIf="isFirstTimeSetup">
                Set a password to finish securing your account. You can keep
                signing in with Google — this just gives you a password as a
                backup way to log in.
            </ng-container>
            <ng-container *ngIf="!isFirstTimeSetup">
                Enter your current password, then choose a new one.
            </ng-container>
        </p>
    </div>

    <div class="rp-alert" *ngIf="errorMessage" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
    </div>

    <form
        class="rp-form"
        [formGroup]="resetPasswordForm"
        (ngSubmit)="onSubmit()"
        novalidate
    >
        <!-- Current password — only when the user already has one -->
        <mat-form-field
            *ngIf="!isFirstTimeSetup"
            class="rp-field"
            appearance="outline"
        >
            <mat-label>Current password</mat-label>
            <mat-icon matPrefix>lock</mat-icon>
            <input
                matInput
                [type]="hideCurrent ? 'password' : 'text'"
                formControlName="currentPassword"
                autocomplete="current-password"
            />
            <button
                mat-icon-button
                matSuffix
                type="button"
                tabindex="-1"
                (click)="hideCurrent = !hideCurrent"
                [attr.aria-label]="
                    hideCurrent ? 'Show password' : 'Hide password'
                "
            >
                <mat-icon>
                    {{ hideCurrent ? 'visibility_off' : 'visibility' }}
                </mat-icon>
            </button>
            <mat-error *ngIf="f['currentPassword']?.hasError('required')">
                Current password is
                <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <!-- New password -->
        <mat-form-field class="rp-field" appearance="outline">
            <mat-label>New password</mat-label>
            <mat-icon matPrefix>vpn_key</mat-icon>
            <input
                matInput
                [type]="hideNew ? 'password' : 'text'"
                formControlName="newPassword"
                autocomplete="new-password"
            />
            <button
                mat-icon-button
                matSuffix
                type="button"
                tabindex="-1"
                (click)="hideNew = !hideNew"
                [attr.aria-label]="hideNew ? 'Show password' : 'Hide password'"
            >
                <mat-icon>
                    {{ hideNew ? 'visibility_off' : 'visibility' }}
                </mat-icon>
            </button>
            <mat-hint>Use at least 8 characters.</mat-hint>
            <mat-error *ngIf="f['newPassword']?.hasError('required')">
                New password is
                <strong>required</strong>
            </mat-error>
            <mat-error *ngIf="f['newPassword']?.hasError('minlength')">
                Must be at least 8 characters
            </mat-error>
        </mat-form-field>

        <!-- Confirm new password -->
        <mat-form-field class="rp-field" appearance="outline">
            <mat-label>Confirm new password</mat-label>
            <mat-icon matPrefix>vpn_key</mat-icon>
            <input
                matInput
                [type]="hideConfirm ? 'password' : 'text'"
                formControlName="retypeNewPassword"
                autocomplete="new-password"
            />
            <button
                mat-icon-button
                matSuffix
                type="button"
                tabindex="-1"
                (click)="hideConfirm = !hideConfirm"
                [attr.aria-label]="
                    hideConfirm ? 'Show password' : 'Hide password'
                "
            >
                <mat-icon>
                    {{ hideConfirm ? 'visibility_off' : 'visibility' }}
                </mat-icon>
            </button>
            <mat-error *ngIf="f['retypeNewPassword']?.hasError('required')">
                Please confirm your new password
            </mat-error>
            <mat-error
                *ngIf="
                    resetPasswordForm.hasError('passwordMismatch') &&
                    !f['retypeNewPassword']?.hasError('required')
                "
            >
                Passwords do not match
            </mat-error>
        </mat-form-field>

        <div class="rp-actions">
            <button
                *ngIf="!isFirstTimeSetup"
                mat-stroked-button
                type="button"
                class="rp-cancel"
                (click)="onCancel()"
                [disabled]="isSubmitting"
            >
                Cancel
            </button>
            <button
                mat-flat-button
                color="primary"
                type="submit"
                class="rp-submit"
                [disabled]="isSubmitting"
            >
                <span *ngIf="!isSubmitting">
                    {{ isFirstTimeSetup ? 'Set password' : 'Update password' }}
                </span>
                <mat-spinner *ngIf="isSubmitting" diameter="22"></mat-spinner>
            </button>
        </div>
    </form>
</div>
